import produce from 'immer';
import { ActionTypes } from '../actions/talkToUs';

export const initialState = {
    TalkToUsIsOpen: false,
};

function TalkToUs(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case ActionTypes.OPEN_TALK_TO_US:
                draft.TalkToUsIsOpen = true;
                return draft;
            case ActionTypes.CLOSE_TALK_TO_US:
                draft.TalkToUsIsOpen = false;
                return draft;
            default:
                return draft;
        }
    });
}

export default TalkToUs;
